import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ROUTE_UI_SECTION_NAME } from '../../../../../constants/route'
import { useNotification, useSectionPermissions } from '../../../../../hooks'
import {
  LabelFormModal,
  LabelSelectDropdownListFooter,
  showLabelSelectDropdownListFooter,
} from '../../../../Label'

import { getCreateLabelInitValues } from './useProfileLabelsWidgetCreateLabel.utils'

export function useProfileLabelsWidgetCreateLabel({
  entity,
  onAddCreatedLabel,
  onClose,
}) {
  const { t } = useTranslation()

  const { handleAddSuccessNotification } = useNotification()

  const { canCreate: canCreateLabels } = useSectionPermissions({
    sectionName: ROUTE_UI_SECTION_NAME.settingsLabels,
  })

  const [createLabelModal, setCreateLabelModal] = useState(null)

  const skipCloseDropdownRef = useRef(false)

  function handleCloseCreateLabelModal() {
    setCreateLabelModal(null)

    onClose()
  }

  function handleCreateLabelSuccess(createdLabel) {
    setCreateLabelModal(null)

    handleAddSuccessNotification({
      text: t('Label.CreateLabelTextNotificationKey', {
        name: createdLabel.name,
      }),
      title: t('Label.CreateLabelNotificationTitleKey'),
    })

    onAddCreatedLabel(createdLabel)
  }

  function handleOpenCreateLabelModal() {
    skipCloseDropdownRef.current = true

    setCreateLabelModal(
      <LabelFormModal
        initValues={getCreateLabelInitValues(entity)}
        onClose={handleCloseCreateLabelModal}
        onSuccess={handleCreateLabelSuccess}
      />
    )
  }

  const labelSelectListProps = canCreateLabels
    ? {
        Footer: LabelSelectDropdownListFooter,
        footerProps: {
          onAddNewLabel: handleOpenCreateLabelModal,
        },
        showFooter: showLabelSelectDropdownListFooter,
      }
    : undefined

  return {
    createLabelModal,
    labelSelectListProps,
    skipCloseDropdownRef,
  }
}
